/**
 * useCommunityRhythmToday Hook
 * 
 * Fetches today's community rhythm (theme) from the backend.
 */

import { useState, useEffect, useCallback, useContext } from 'react';
import apiClient from "../api/client";
import { AuthContext } from '../App';


export function useCommunityRhythmToday() {
  const { token } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const fetchRhythm = useCallback(async () => {
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      const res = await apiClient.get(`/community/rhythm/today`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(res.data);
      setError(null);
    } catch (err) {
      console.error('[useCommunityRhythmToday] Failed to fetch:', err);
      setError(err?.response?.data?.detail || 'Failed to load rhythm');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchRhythm();
  }, [fetchRhythm]);

  return {
    loading,
    error,
    data,
    refetch: fetchRhythm,
    date: data?.date || null,
    weekday: data?.weekday || null,
    theme: data?.theme || null,
    tagline: data?.tagline || null,
    hasTheme: !!data?.theme && data.theme !== 'Open',
  };
}

export default useCommunityRhythmToday;
